export const services = [
  {
    name: 'Traditional Thai Massage',
    slug: 'thai-massage',
    description: 'The massage that gives you refreshment and boosts your energy instantly. This dry massage will heal your body with the combination of acupressure and continuous stretching techniques. <br>Kindly let us know how firm you would like it to be, we will adjust the intensity to suit your needs.',
    price: 'AU$99 per 60 min',
    presure: 'Medium to hard pressure',
    precaution: 'Due to its impact on the circulatory system, people with health conditions should consult with a GP first. Not recommended for after recent severe injury.  Not recommended for pregnant women.',
    banner_image: '/images/banner-thai.jpg',
    feature_image: '/images/thai1.jpg',
    cover_image: '/images/thai2.jpg'
  },
  {
    name: 'Thai Oil Massage',
    slug: 'thai-oil',
    description: 'A mix of stretching, firm pressure and deep rhythmic movements along energy lines throughout your body. This massage is similar to Traditional Thai Massage but is enhanced with the use of our special oils, resulting in a more smooth and relaxing experience. Boosts your endorphins for stress release.',
    price: 'AU$99 per 60 min',
    presure: 'Light to medium pressure',
    banner_image: '/images/oil-banner.jpg',
    feature_image: '/images/oil-feature.jpg',
    cover_image: '/images/thai_cover.jpg'
  },
  {
    name: 'Organic Coconut Oil & Hot Stone Massage',
    slug: 'coconut-oil',
    description: 'Down to nature, we are using organic coconut oil for this massage session. The coconut oil can be absorbed easily and act like a shield for your skin from environmental toxins after massage. Also helping to diminish the signs of ageing. Additional with hot stone which provides deep aids to your muscle.',
    price: 'AU$99 per 60 min',
    presure: 'Light to medium pressure',
    banner_image: '/images/coco+hotstone.jpg',
    cover_image: '/images/hot-stone.jpg'
  },
  {
    name: 'Remedial / Deep Tissue Massage',
    slug: 'remedial-deep',
    description: "Breaking up your scar tissue or stiffness with deep/remedial massage. The session starts from a lighter pressure to warm up your muscles and builds into deeper pressure that breaks down tied ‘knots’. Because this massage's goal is to fix issues in the muscles, you will be expecting a little discomfort or slight pain.",
    price: 'AU$99 per 60 min',
    precaution: 'Due to its impact on the circulatory system, people with health conditions should consult with a GP first. Not recommended for after recent severe injury',
    cover_image: '/images/oil-massage.jpg'
  },
  {
    name: 'Foot Massage',
    slug: 'foot-massage',
    description: "A foot massage is a therapeutic treatment in which the feet and ankles are massaged to promote relaxation and alleviate stress and tension. It is often performed using a combination of techniques, such as kneading, rubbing, and applying pressure to specific points on the feet. Some foot massage treatments may also include the use of oils or lotions to moisturize the skin and improve circulation. Foot massages can be relaxing and invigorating, and they may provide a number of health benefits, such as reducing pain and swelling, improving sleep, and boosting the immune system. Many people find foot massages to be a soothing and rejuvenating experience, and they may be especially beneficial for those who are on their feet for long periods of time or who experience discomfort or pain in their feet and ankles.",
    price: 'AU$99 per 60 min',
  },
]